var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdPlanSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Megaphone-2--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Megaphone 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "megaphone-2--bullhorn-loud-megaphone-share-speaker-transmit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#000000",
    fillRule: "evenodd",
    d: "M5.25 3.49994 11.9563 0.794702C12.9396 0.412306 14 1.13767 14 2.19271v8.22609c0 1.0238 -1.003 1.7468 -1.9743 1.423L5.25 9.49994v-6ZM3 3.5h1v7c0 0.5523 0.44772 1 1 1h0.5c0.55228 0 1 0.4477 1 1s-0.44772 1 -1 1H5c-1.65685 0 -3 -1.3431 -3 -3V9.32929C0.834808 8.91746 0 7.80622 0 6.5c0 -1.65685 1.34315 -3 3 -3Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdPlanSolid);
export default __webpack_public_path__ + "static/media/ad-plan-solid.db344c88cdfeca7d2c89935d54276393.svg";
export { ForwardRef as ReactComponent };